import { call, put, takeLatest } from "redux-saga/effects";
import { archiveWorkflowApi } from "../../../api/apiLists/workflow";
import {
  archiveWorkflowFailure,
  archiveWorkflowRequest,
  archiveWorkflowStart,
  archiveWorkflowSuccess
} from "../../slices/workflow";
import { callWorkflowApi, requireWhatsAppModuleAccess } from "./workflowSagaHelper";

function* handleArchiveWorkflow(action) {
  if (!(yield call(requireWhatsAppModuleAccess))) return;

  try {
    yield put(archiveWorkflowStart());

    const req = action.payload || { operation: "ARCHIVE_WORKFLOW", payload: {} };
    const res = yield callWorkflowApi(archiveWorkflowApi, req);

    if (res?.status) {
      yield put(archiveWorkflowSuccess(res?.data || null));
      return;
    }

    yield put(archiveWorkflowFailure(res?.errMsg || "Failed to archive workflow"));
  } catch (error) {
    yield put(archiveWorkflowFailure(error.message || "Failed to archive workflow"));
  }
}

export default function* workflowArchiveSaga() {
  yield takeLatest(archiveWorkflowRequest.type, handleArchiveWorkflow);
}
